var _path, _g, _g2, _g3, _g4, _path2, _path3, _path4, _path5, _path6, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65548 4.96495C9.61498 5.44045 9.04048 5.67895 8.67523 5.36995C8.19823 4.96495 7.69198 4.5697 7.31548 4.35895C6.29398 3.7852 5.68123 3.6727 4.69273 4.63645L4.66648 4.66345L4.65148 4.67845L4.63948 4.69045C3.67648 5.67895 3.78748 6.29095 4.36198 7.31245C4.57498 7.69345 4.97698 8.20645 5.38648 8.6887C5.69623 9.0532 5.45773 9.62995 4.98073 9.66895C4.35073 9.7207 3.70423 9.79945 3.28423 9.91645C2.15623 10.2337 1.64398 10.5877 1.62598 11.9677V12.0442C1.64398 13.4242 2.15623 13.7782 3.28348 14.0947C3.69748 14.211 4.33198 14.289 4.95298 14.3407C5.42923 14.3805 5.66773 14.9557 5.35873 15.3202C4.95973 15.7927 4.57048 16.2922 4.36123 16.6635C3.78748 17.685 3.67648 18.2977 4.63948 19.2862L4.65148 19.299L4.66648 19.314L4.69273 19.3402C5.68123 20.3032 6.29398 20.1915 7.31548 19.6177C7.69648 19.404 8.21098 19.0005 8.69398 18.5902C9.05923 18.2812 9.63523 18.5197 9.67423 18.9967C9.72673 19.6267 9.80473 20.2747 9.92323 20.6955C10.2397 21.8235 10.5937 22.3357 11.9737 22.353H12.0495C13.4295 22.335 13.7842 21.8235 14.1007 20.6955C14.2155 20.286 14.2927 19.6612 14.3445 19.047C14.385 18.5707 14.9595 18.333 15.3247 18.642C15.8017 19.0462 16.308 19.4415 16.6845 19.653C17.706 20.2267 18.318 20.3385 19.3072 19.3755L19.3335 19.3485L19.3425 19.3395L19.3485 19.3335L19.3605 19.3215C20.3235 18.333 20.2125 17.7202 19.638 16.6987C19.425 16.3185 19.023 15.8047 18.6135 15.3232C18.3037 14.958 18.5422 14.382 19.0192 14.343C19.6492 14.2905 20.2957 14.2125 20.7157 14.0947C21.8437 13.7782 22.356 13.4242 22.374 12.0442V11.9677C22.356 10.5877 21.8437 10.2337 20.7165 9.9172C20.3025 9.80095 19.668 9.72295 19.047 9.6712C18.5707 9.63145 18.3322 9.0562 18.6412 8.6917C19.0402 8.2192 19.4295 7.7197 19.6387 7.3477C20.2125 6.3262 20.3235 5.7142 19.3605 4.7257L19.3485 4.71295L19.3335 4.69795L19.3072 4.6717C18.318 3.70795 17.706 3.8197 16.6845 4.3942C16.3035 4.60795 15.789 5.01145 15.306 5.4217C14.9407 5.7307 14.3647 5.4922 14.325 5.0152C14.2732 4.3852 14.1952 3.73645 14.0775 3.31645C13.761 2.18845 13.4062 1.6762 12.0262 1.6582H11.9505C10.5705 1.6762 10.2157 2.18845 9.89923 3.3157C9.78448 3.7252 9.70723 4.35145 9.65548 4.96495ZM11.997 16.0597C13.0723 16.0597 14.1036 15.6325 14.8639 14.8722C15.6243 14.1118 16.0515 13.0805 16.0515 12.0052C16.0515 10.9299 15.6243 9.89861 14.8639 9.13824C14.1036 8.37787 13.0723 7.9507 11.997 7.9507C10.9217 7.9507 9.89038 8.37787 9.13001 9.13824C8.36965 9.89861 7.94248 10.9299 7.94248 12.0052C7.94248 13.0805 8.36965 14.1118 9.13001 14.8722C9.89038 15.6325 10.9217 16.0597 11.997 16.0597Z",
    fill: "url(#paint0_linear_222_6449)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_222_6449)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65548 4.96495C9.61498 5.44045 9.04048 5.67895 8.67523 5.36995C8.19823 4.96495 7.69198 4.5697 7.31548 4.35895C6.29398 3.7852 5.68123 3.6727 4.69273 4.63645L4.66648 4.66345L4.65148 4.67845L4.63948 4.69045C3.67648 5.67895 3.78748 6.29095 4.36198 7.31245C4.57498 7.69345 4.97698 8.20645 5.38648 8.6887C5.69623 9.0532 5.45773 9.62995 4.98073 9.66895C4.35073 9.7207 3.70423 9.79945 3.28423 9.91645C2.15623 10.2337 1.64398 10.5877 1.62598 11.9677V12.0442C1.64398 13.4242 2.15623 13.7782 3.28348 14.0947C3.69748 14.211 4.33198 14.289 4.95298 14.3407C5.42923 14.3805 5.66773 14.9557 5.35873 15.3202C4.95973 15.7927 4.57048 16.2922 4.36123 16.6635C3.78748 17.685 3.67648 18.2977 4.63948 19.2862L4.65148 19.299L4.66648 19.314L4.69273 19.3402C5.68123 20.3032 6.29398 20.1915 7.31548 19.6177C7.69648 19.404 8.21098 19.0005 8.69398 18.5902C9.05923 18.2812 9.63523 18.5197 9.67423 18.9967C9.72673 19.6267 9.80473 20.2747 9.92323 20.6955C10.2397 21.8235 10.5937 22.3357 11.9737 22.353H12.0495C13.4295 22.335 13.7842 21.8235 14.1007 20.6955C14.2155 20.286 14.2927 19.6612 14.3445 19.047C14.385 18.5707 14.9595 18.333 15.3247 18.642C15.8017 19.0462 16.308 19.4415 16.6845 19.653C17.706 20.2267 18.318 20.3385 19.3072 19.3755L19.3335 19.3485L19.3425 19.3395L19.3485 19.3335L19.3605 19.3215C20.3235 18.333 20.2125 17.7202 19.638 16.6987C19.425 16.3185 19.023 15.8047 18.6135 15.3232C18.3037 14.958 18.5422 14.382 19.0192 14.343C19.6492 14.2905 20.2957 14.2125 20.7157 14.0947C21.8437 13.7782 22.356 13.4242 22.374 12.0442V11.9677C22.356 10.5877 21.8437 10.2337 20.7165 9.9172C20.3025 9.80095 19.668 9.72295 19.047 9.6712C18.5707 9.63145 18.3322 9.0562 18.6412 8.6917C19.0402 8.2192 19.4295 7.7197 19.6387 7.3477C20.2125 6.3262 20.3235 5.7142 19.3605 4.7257L19.3485 4.71295L19.3335 4.69795L19.3072 4.6717C18.318 3.70795 17.706 3.8197 16.6845 4.3942C16.3035 4.60795 15.789 5.01145 15.306 5.4217C14.9407 5.7307 14.3647 5.4922 14.325 5.0152C14.2732 4.3852 14.1952 3.73645 14.0775 3.31645C13.761 2.18845 13.4062 1.6762 12.0262 1.6582H11.9505C10.5705 1.6762 10.2157 2.18845 9.89923 3.3157C9.78448 3.7252 9.70723 4.35145 9.65548 4.96495ZM11.997 16.0597C13.0723 16.0597 14.1036 15.6325 14.8639 14.8722C15.6243 14.1118 16.0515 13.0805 16.0515 12.0052C16.0515 10.9299 15.6243 9.89861 14.8639 9.13824C14.1036 8.37787 13.0723 7.9507 11.997 7.9507C10.9217 7.9507 9.89038 8.37787 9.13001 9.13824C8.36965 9.89861 7.94248 10.9299 7.94248 12.0052C7.94248 13.0805 8.36965 14.1118 9.13001 14.8722C9.89038 15.6325 10.9217 16.0597 11.997 16.0597Z",
    fill: "url(#paint1_linear_222_6449)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_222_6449)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18.111C13.6192 18.111 15.172 17.4678 16.3169 16.3229C17.4618 15.178 18.105 13.6251 18.105 12.006C18.105 10.3869 17.4618 8.83402 16.3169 7.68911C15.172 6.5442 13.6192 5.901 12 5.901C10.3809 5.901 8.82804 6.5442 7.68313 7.68911C6.53822 8.83402 5.89502 10.3869 5.89502 12.006C5.89502 13.6251 6.53822 15.178 7.68313 16.3229C8.82804 17.4678 10.3809 18.111 12 18.111ZM12 15.7583C12.9952 15.7583 13.9496 15.3629 14.6533 14.6592C15.3569 13.9556 15.7523 13.0012 15.7523 12.006C15.7523 11.0108 15.3569 10.0564 14.6533 9.35276C13.9496 8.64908 12.9952 8.25375 12 8.25375C11.0049 8.25375 10.0505 8.64908 9.34678 9.35276C8.64309 10.0564 8.24777 11.0108 8.24777 12.006C8.24777 13.0012 8.64309 13.9556 9.34678 14.6592C10.0505 15.3629 11.0049 15.7583 12 15.7583Z",
    fill: "url(#paint2_linear_222_6449)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18.111C13.6192 18.111 15.172 17.4678 16.3169 16.3229C17.4618 15.178 18.105 13.6251 18.105 12.006C18.105 10.3869 17.4618 8.83402 16.3169 7.68911C15.172 6.5442 13.6192 5.901 12 5.901C10.3809 5.901 8.82804 6.5442 7.68313 7.68911C6.53822 8.83402 5.89502 10.3869 5.89502 12.006C5.89502 13.6251 6.53822 15.178 7.68313 16.3229C8.82804 17.4678 10.3809 18.111 12 18.111ZM12 15.7583C12.9952 15.7583 13.9496 15.3629 14.6533 14.6592C15.3569 13.9556 15.7523 13.0012 15.7523 12.006C15.7523 11.0108 15.3569 10.0564 14.6533 9.35276C13.9496 8.64908 12.9952 8.25375 12 8.25375C11.0049 8.25375 10.0505 8.64908 9.34678 9.35276C8.64309 10.0564 8.24777 11.0108 8.24777 12.006C8.24777 13.0012 8.64309 13.9556 9.34678 14.6592C10.0505 15.3629 11.0049 15.7583 12 15.7583Z",
    fill: "url(#paint3_radial_222_6449)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_222_6449)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 17.9265C12.783 17.9353 13.5601 17.7887 14.2862 17.4951C15.0123 17.2015 15.6729 16.7667 16.2298 16.2161C16.7867 15.6654 17.2289 15.0097 17.5306 14.2869C17.8324 13.5642 17.9878 12.7888 17.9878 12.0056C17.9878 11.2224 17.8324 10.447 17.5306 9.72425C17.2289 9.00152 16.7867 8.34583 16.2298 7.79515C15.6729 7.24447 15.0123 6.80975 14.2862 6.51615C13.5601 6.22255 12.783 6.07591 11.9999 6.08473C10.4294 6.08473 8.92336 6.70857 7.81291 7.81902C6.70246 8.92947 6.07861 10.4356 6.07861 12.006C6.07861 13.5764 6.70246 15.0825 7.81291 16.1929C8.92336 17.3034 10.4294 17.9265 11.9999 17.9265ZM11.9999 15.645C12.4821 15.6519 12.9609 15.5629 13.4084 15.3831C13.8559 15.2034 14.2633 14.9365 14.6067 14.5979C14.9502 14.2594 15.2229 13.8559 15.4091 13.411C15.5952 12.9661 15.6911 12.4886 15.6911 12.0064C15.6911 11.5241 15.5952 11.0466 15.4091 10.6017C15.2229 10.1568 14.9502 9.75335 14.6067 9.41478C14.2633 9.07622 13.8559 8.80931 13.4084 8.62955C12.9609 8.4498 12.4821 8.3608 11.9999 8.36773C11.0439 8.38145 10.1317 8.77084 9.46054 9.45173C8.78936 10.1326 8.4131 11.0503 8.4131 12.0064C8.4131 12.9624 8.78936 13.8801 9.46054 14.561C10.1317 15.2419 11.0439 15.6313 11.9999 15.645Z",
    fill: "url(#paint4_radial_222_6449)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_222_6449)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 16.137C12.5426 16.137 13.0798 16.0301 13.581 15.8225C14.0822 15.6149 14.5376 15.3107 14.9212 14.9271C15.3048 14.5435 15.6091 14.0881 15.8167 13.5869C16.0243 13.0857 16.1311 12.5485 16.1311 12.006C16.1311 11.4635 16.0243 10.9263 15.8167 10.4251C15.6091 9.92394 15.3048 9.46854 14.9212 9.08494C14.5376 8.70134 14.0822 8.39706 13.581 8.18945C13.0798 7.98185 12.5426 7.875 12.0001 7.875C10.9045 7.875 9.8538 8.31023 9.07908 9.08494C8.30437 9.85965 7.86914 10.9104 7.86914 12.006C7.86914 13.1016 8.30437 14.1523 9.07908 14.9271C9.8538 15.7018 10.9045 16.137 12.0001 16.137ZM15.6391 12.006C15.6391 12.4839 15.545 12.9571 15.3621 13.3986C15.1793 13.8401 14.9112 14.2413 14.5733 14.5792C14.2354 14.9171 13.8342 15.1851 13.3927 15.368C12.9512 15.5509 12.478 15.645 12.0001 15.645C11.5223 15.645 11.0491 15.5509 10.6076 15.368C10.1661 15.1851 9.76489 14.9171 9.42698 14.5792C9.08907 14.2413 8.82102 13.8401 8.63814 13.3986C8.45527 12.9571 8.36114 12.4839 8.36114 12.006C8.36114 11.0409 8.74453 10.1153 9.42698 9.43284C10.1094 8.75039 11.035 8.367 12.0001 8.367C12.9653 8.367 13.8909 8.75039 14.5733 9.43284C15.2557 10.1153 15.6391 11.0409 15.6391 12.006Z",
    fill: "url(#paint5_linear_222_6449)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 16.1076C13.088 16.1076 14.1313 15.6755 14.9006 14.9062C15.6698 14.137 16.1019 13.0937 16.1019 12.0059C16.1019 10.918 15.6698 9.87472 14.9006 9.10549C14.1313 8.33626 13.088 7.90411 12.0002 7.90411C10.9123 7.90411 9.86904 8.33626 9.09981 9.10549C8.33059 9.87472 7.89844 10.918 7.89844 12.0059C7.89844 13.0937 8.33059 14.137 9.09981 14.9062C9.86904 15.6755 10.9123 16.1076 12.0002 16.1076ZM12.0002 15.2519C12.8611 15.2519 13.6867 14.9099 14.2955 14.3011C14.9042 13.6924 15.2462 12.8668 15.2462 12.0059C15.2462 11.145 14.9042 10.3193 14.2955 9.7106C13.6867 9.10185 12.8611 8.75986 12.0002 8.75986C11.1393 8.75986 10.3137 9.10185 9.70492 9.7106C9.09618 10.3193 8.75419 11.145 8.75419 12.0059C8.75419 12.8668 9.09618 13.6924 9.70492 14.3011C10.3137 14.9099 11.1393 15.2519 12.0002 15.2519Z",
    fill: "url(#paint6_radial_222_6449)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 16.1076C13.088 16.1076 14.1313 15.6755 14.9006 14.9062C15.6698 14.137 16.1019 13.0937 16.1019 12.0059C16.1019 10.918 15.6698 9.87472 14.9006 9.10549C14.1313 8.33626 13.088 7.90411 12.0002 7.90411C10.9123 7.90411 9.86904 8.33626 9.09981 9.10549C8.33059 9.87472 7.89844 10.918 7.89844 12.0059C7.89844 13.0937 8.33059 14.137 9.09981 14.9062C9.86904 15.6755 10.9123 16.1076 12.0002 16.1076ZM12.0002 15.2519C12.8611 15.2519 13.6867 14.9099 14.2955 14.3011C14.9042 13.6924 15.2462 12.8668 15.2462 12.0059C15.2462 11.145 14.9042 10.3193 14.2955 9.7106C13.6867 9.10185 12.8611 8.75986 12.0002 8.75986C11.1393 8.75986 10.3137 9.10185 9.70492 9.7106C9.09618 10.3193 8.75419 11.145 8.75419 12.0059C8.75419 12.8668 9.09618 13.6924 9.70492 14.3011C10.3137 14.9099 11.1393 15.2519 12.0002 15.2519Z",
    fill: "url(#paint7_radial_222_6449)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 15.7086C12.4904 15.7156 12.9776 15.625 13.433 15.442C13.8885 15.2591 14.3029 14.9874 14.6524 14.6428C15.0019 14.2983 15.2795 13.8877 15.4689 13.4349C15.6583 12.9822 15.7559 12.4963 15.7559 12.0055C15.7559 11.5147 15.6583 11.0288 15.4689 10.5761C15.2795 10.1233 15.0019 9.71272 14.6524 9.36817C14.3029 9.02361 13.8885 8.75195 13.433 8.56898C12.9776 8.38602 12.4904 8.29539 11.9997 8.30238C11.0267 8.31622 10.0982 8.71247 9.41504 9.40543C8.73187 10.0984 8.34888 11.0324 8.34888 12.0055C8.34888 12.9786 8.73187 13.9126 9.41504 14.6056C10.0982 15.2985 11.0267 15.6948 11.9997 15.7086ZM15.2457 12.0059C15.2457 12.8668 14.9037 13.6924 14.2949 14.3011C13.6862 14.9099 12.8606 15.2519 11.9997 15.2519C11.1388 15.2519 10.3131 14.9099 9.70441 14.3011C9.09566 13.6924 8.75368 12.8668 8.75368 12.0059C8.75368 11.145 9.09566 10.3194 9.70441 9.71061C10.3131 9.10187 11.1388 8.75988 11.9997 8.75988C12.8606 8.75988 13.6862 9.10187 14.2949 9.71061C14.9037 10.3194 15.2457 11.145 15.2457 12.0059Z",
    fill: "url(#paint8_radial_222_6449)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 15.7086C12.4904 15.7156 12.9776 15.625 13.433 15.442C13.8885 15.2591 14.3029 14.9874 14.6524 14.6428C15.0019 14.2983 15.2795 13.8877 15.4689 13.4349C15.6583 12.9822 15.7559 12.4963 15.7559 12.0055C15.7559 11.5147 15.6583 11.0288 15.4689 10.5761C15.2795 10.1233 15.0019 9.71272 14.6524 9.36817C14.3029 9.02361 13.8885 8.75195 13.433 8.56898C12.9776 8.38602 12.4904 8.29539 11.9997 8.30238C11.0267 8.31622 10.0982 8.71247 9.41504 9.40543C8.73187 10.0984 8.34888 11.0324 8.34888 12.0055C8.34888 12.9786 8.73187 13.9126 9.41504 14.6056C10.0982 15.2985 11.0267 15.6948 11.9997 15.7086ZM15.2457 12.0059C15.2457 12.8668 14.9037 13.6924 14.2949 14.3011C13.6862 14.9099 12.8606 15.2519 11.9997 15.2519C11.1388 15.2519 10.3131 14.9099 9.70441 14.3011C9.09566 13.6924 8.75368 12.8668 8.75368 12.0059C8.75368 11.145 9.09566 10.3194 9.70441 9.71061C10.3131 9.10187 11.1388 8.75988 11.9997 8.75988C12.8606 8.75988 13.6862 9.10187 14.2949 9.71061C14.9037 10.3194 15.2457 11.145 15.2457 12.0059Z",
    fill: "url(#paint9_radial_222_6449)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 15.7086C12.4904 15.7156 12.9776 15.625 13.433 15.442C13.8885 15.2591 14.3029 14.9874 14.6524 14.6428C15.0019 14.2983 15.2795 13.8877 15.4689 13.4349C15.6583 12.9822 15.7559 12.4963 15.7559 12.0055C15.7559 11.5147 15.6583 11.0288 15.4689 10.5761C15.2795 10.1233 15.0019 9.71272 14.6524 9.36817C14.3029 9.02361 13.8885 8.75195 13.433 8.56898C12.9776 8.38602 12.4904 8.29539 11.9997 8.30238C11.0267 8.31622 10.0982 8.71247 9.41504 9.40543C8.73187 10.0984 8.34888 11.0324 8.34888 12.0055C8.34888 12.9786 8.73187 13.9126 9.41504 14.6056C10.0982 15.2985 11.0267 15.6948 11.9997 15.7086ZM15.2457 12.0059C15.2457 12.8668 14.9037 13.6924 14.2949 14.3011C13.6862 14.9099 12.8606 15.2519 11.9997 15.2519C11.1388 15.2519 10.3131 14.9099 9.70441 14.3011C9.09566 13.6924 8.75368 12.8668 8.75368 12.0059C8.75368 11.145 9.09566 10.3194 9.70441 9.71061C10.3131 9.10187 11.1388 8.75988 11.9997 8.75988C12.8606 8.75988 13.6862 9.10187 14.2949 9.71061C14.9037 10.3194 15.2457 11.145 15.2457 12.0059Z",
    fill: "url(#paint10_radial_222_6449)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_222_6449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 15.7086C12.4907 15.7156 12.9779 15.625 13.4333 15.442C13.8887 15.2591 14.3032 14.9874 14.6527 14.6428C15.0022 14.2983 15.2797 13.8877 15.4691 13.4349C15.6586 12.9822 15.7561 12.4963 15.7561 12.0055C15.7561 11.5147 15.6586 11.0288 15.4691 10.5761C15.2797 10.1233 15.0022 9.71272 14.6527 9.36817C14.3032 9.02361 13.8887 8.75195 13.4333 8.56898C12.9779 8.38602 12.4907 8.29539 11.9999 8.30238C11.0269 8.31622 10.0985 8.71247 9.41528 9.40543C8.73211 10.0984 8.34912 11.0324 8.34912 12.0055C8.34912 12.9786 8.73211 13.9126 9.41528 14.6056C10.0985 15.2985 11.0269 15.6948 11.9999 15.7086Z",
    stroke: "url(#paint11_radial_222_6449)",
    strokeWidth: 0.075
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_222_6449",
    x: 1.47598,
    y: 1.5082,
    width: 21.048,
    height: 20.9947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.533333 0 0 0 0 0.717647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_222_6449"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.941176 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_222_6449",
    result: "effect2_innerShadow_222_6449"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: 0.075
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.6 0 0 0 0 0.631373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_222_6449",
    result: "effect3_innerShadow_222_6449"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_222_6449",
    x: 5.52002,
    y: 5.526,
    width: 12.96,
    height: 12.96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875,
    result: "effect1_foregroundBlur_222_6449"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_222_6449",
    x: 6.07861,
    y: 5.89685,
    width: 12.0967,
    height: 12.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1875,
    dy: -0.1875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.596078 0 0 0 0 0.521569 0 0 0 0 0.682353 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_222_6449"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_222_6449",
    x: 7.79414,
    y: 7.8,
    width: 8.41196,
    height: 8.412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0375,
    result: "effect1_foregroundBlur_222_6449"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_222_6449",
    x: 8.23652,
    y: 8.1895,
    width: 7.63218,
    height: 7.632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0375,
    result: "effect1_foregroundBlur_222_6449"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_6449",
    x1: 19.3597,
    y1: 4.5472,
    x2: 4.59373,
    y2: 19.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1B4D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_6449",
    x1: 19.3597,
    y1: 4.5472,
    x2: 4.59373,
    y2: 19.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1B4D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_6449",
    x1: 15.75,
    y1: 7.08375,
    x2: 10.1955,
    y2: 17.9535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0CCD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#A38EBE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_222_6449",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.98452 8.71874) rotate(26.764) scale(3.01871 8.3577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#908B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#908B9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_222_6449",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7268 8.36698) rotate(133.81) scale(11.1725 14.5757)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "#E5DFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8BAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_222_6449",
    x1: 14.1796,
    y1: 8.25,
    x2: 12.0001,
    y2: 16.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEA9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9888AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_222_6449",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3277 9.58682) rotate(128.71) scale(8.3574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A89ABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_222_6449",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.39119 9.72661) rotate(32.5741) scale(4.005 8.07368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90899A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90899A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_222_6449",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6942 9.70278) rotate(136.338) scale(7.0951 7.05329)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#C9BFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADA4BB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_222_6449",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.04692 14.7659) rotate(-45.5162) scale(3.67931 5.84892)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#BCB6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB6C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_222_6449",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.58468 8.74188) rotate(49.259) scale(3.12431 5.54654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#A294B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A294B3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_222_6449",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.826 11.6375) rotate(152.789) scale(5.14458 5.09829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#CCC3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A197AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearIcon);
export default __webpack_public_path__ + "static/media/gear-icon.550c4d93000f100e6bf364ed25cbec23.svg";
export { ForwardRef as ReactComponent };